function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "or",
  transform: "translate(-478.826 -389.029)"
}, React.createElement("g", {
  id: "Ellipse_64",
  "data-name": "Ellipse 64",
  transform: "translate(478.826 389.029)",
  fill: "#fff",
  stroke: "#d4d4d4",
  strokeWidth: 1
}, React.createElement("ellipse", {
  cx: 13.874,
  cy: 13.874,
  rx: 13.874,
  ry: 13.874,
  stroke: "none"
}), React.createElement("ellipse", {
  cx: 13.874,
  cy: 13.874,
  rx: 13.374,
  ry: 13.374,
  fill: "none"
})), React.createElement("text", {
  id: "OR-2",
  "data-name": "OR",
  transform: "translate(492.825 406.778)",
  fill: "#b9b9b9",
  fontSize: 10,
  fontFamily: "Poppins-Medium, Poppins",
  fontWeight: 500
}, React.createElement("tspan", {
  x: -7.08,
  y: 0
}, "OR")));
var SvgOr = function SvgOr(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 27.748,
    height: 27.748,
    viewBox: "0 0 27.748 27.748",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/or.65677e3f.svg";
export { ForwardRef as ReactComponent };